import { useContext } from 'react';
import { IconMoon } from '@components/icons/icon-moon';
import { IconSun } from '@components/icons/icon-sun';
import SwitchToggle from '@components/switch-toggle/switch-toggle';
import { DarkModeContext } from '@contexts/dark-mode/dark-mode-context';
import classNames from 'classnames';

export const DarkModeToggle = ({ className }: { className?: string }) => {
  const { isDarkMode, toggleDarkMode, isActive } = useContext(DarkModeContext);

  return (
    <div
      className={classNames(className, {
        hidden: !isActive,
      })}>
      <SwitchToggle
        active={isDarkMode}
        onToggleSwitch={(_, e) => toggleDarkMode(e)}
        ariaLabel='Dark mode'
        loading={false}
        activeIcon={<IconMoon className='w-2.5 h-2.5 text-primary' />}
        inactiveIcon={<IconSun className='w-2.5 h-2.5 text-primary' />}
      />
    </div>
  );
};

export default DarkModeToggle;
